(() => {
  if (customElements.get('lux-video-hero')) return;
  customElements.define('lux-video-hero', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.video.pause();
      }, options);
      this.video.muted = true;
      if (this.motion.matches) {
        this.video.autoplay = false;
        this.video.pause();
      }
    }
    disconnectedCallback() {
      this.events?.abort();
    }
  });
})();
